import { createMuiTheme, Theme, ThemeOptions } from "@material-ui/core/styles";
import merge from "lodash/merge";

export const color = {} as any;
color.red = "rgba(255,7,12,0.92)";
color.green = "#71BF44";
color.grey = "#d7d7d7";
color.white = "#FFF";
color.black = "#272727";

declare module "@material-ui/core/styles/createPalette" {
  export interface TypeBackground {
    header: string;
  }
}

export const incidentColors = {
  critical: "#f44336",
  major: "#F57F17",
  minor: "#FBC02D",
  warning: "#FFEE58",
  indeterminate: "#c1d5e0",
  cleared: "#4caf50"
};

export const createLegoTheme = (options: ThemeOptions): Theme =>
  createMuiTheme(
    merge(
      {
        spacing: 5,
        palette: {
          type: "light",
          background: {
            header: color.black
          }
        },
        props: {
          MuiTableCell: {
            size: "small"
          }
        },
        overrides: {
          MuiOutlinedInput: {
            inputMarginDense: {
              paddingBottom: "0.5em",
              paddingTop: "0.5em"
            }
          },
          MuiMenuItem: {
            root: {
              padding: 5
            }
          }
        }
      },
      options
    )
  );
